import React, { useState } from "react";
import { useToast } from "../../hooks/use-toast";
import { subscribeNewsletter } from "../../lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterSubscribeBox() {
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) {
      toast({ title: "Please enter a valid email address." });
      return;
    }
    setSubmitting(true);
    try {
      const res = await subscribeNewsletter(email);
      setEmail("");
      toast({
        title: res.already_subscribed
          ? "You\u2019re already on our list \u2014 thank you!"
          : "Thank you for subscribing!",
        description: res.already_subscribed
          ? "We have your email saved already."
          : "You\u2019ve been added to our mailing list.",
      });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast({ title: msg });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="bg-white border border-[#d6dcb6] p-4">
      <h3 className="font-display text-[#7d8e54] text-lg mb-2">Subscribe to our mailing list</h3>
      <form onSubmit={onSubmit} className="space-y-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          className="w-full border border-[#d6dcb6] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8da55f]"
        />
        <button
          type="submit"
          disabled={submitting}
          className="nn-sage-dark w-full py-2 text-sm font-display tracking-wide hover:bg-[#5b6a37] transition-colors disabled:opacity-60"
        >
          {submitting ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
    </div>
  );
}
